export { NS, NSType, ActionStatus } from './Data';
export * from './Action';
export { reducer } from './Store';

import DailyCareTasks from './Pages/DailyCareTasks';

export const Pages = {
  DailyCareTasks
};
